import Mailto from "../Components/Mailto";
import Error from "../Layouts/Error";
import InnerHeader from "../Layouts/InnerHeader";
import Loading from "../Layouts/Loading";
import { useGetAllMessagesQuery } from "../Redux/Apis/messageApi";
import { fa_number } from "../utils/Persian";

export default function Message(){
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetAllMessagesQuery({})
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess)
        return(
            <div className="container-lg">
                <InnerHeader name="پیام های کاربران"/>
                <div className="row">
                    {data && data.length > 0 ? <div className="table-responsive"><table className="table">
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">نام</th>
                            <th scope="col">ایمیل</th>
                            <th scope="col">موبایل</th>
                            <th scope="col">موضوع</th>
                            <th scope="col">متن پیام</th>
                            <th scope="col">اقدامات</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.map((value:any,index:number) => 
                            <tr key={index} className="py-2">
                                <th scope="row">{fa_number(index + 1)}</th>
                                <td>{value.name}</td>
                                <td>{value.email}</td>
                                <td>{value.mobile}</td>
                                <td>{value.subject}</td>
                                <td>{value.body.length > 30 ? 
                                    <span>{value.body.substr(0,25).concat('...')} <button onClick={() => window.confirm(value.body)} className="btn btn-link m-0 p-0">(مشاهده کامل)</button></span>
                                    : value.body }
                                </td>
                                <td className="d-grid gap-2 d-md-block justify-content-md-end">
                                    {value.email && <Mailto label={`ارسال ایمیل`} action={`mailto:${value.email}`} />}
                                    {value.mobile && <Mailto label={`تماس`} action={`tel:${value.mobile}`} />}
                                    {value.mobile && <Mailto label={`ارسال پیامک`} action={`sms:${value.mobile}`} />}
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table></div>
                    :
                    <div className="alert d-flex align-items-center" role="alert">
                        <i className="zmdi zmdi-info"></i>
                        <div className="ms-2">
                        پیامی ارسال نشده است.
                        </div>
                    </div>
                    }
                </div>
            </div>
        )

    else return <></>
}